import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const row: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

export const primaryText: CSSProperties = {
  flexGrow: 1,
  color: greys.darkestGrey,
};

export const help: CSSProperties = {
  fontSize: 12,
  color: greys.slate,
};

export const icon = {
  color: greys.slate,
  "&:hover": {
    color: greys.standard,
  },
};

export const styles = {
  icon,
};
